import { render, staticRenderFns } from "./main.vue?vue&type=template&id=6c958c2a&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=6c958c2a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c958c2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c958c2a')) {
      api.createRecord('6c958c2a', component.options)
    } else {
      api.reload('6c958c2a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=6c958c2a&scoped=true", function () {
      api.rerender('6c958c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/campaign/form/main.vue"
export default component.exports